module.exports = __webpack_public_path__ + "static/media/2019.a6febadd.svg";